<template>
  <v-container>
    {{ selectedItem }}
    <h4 class="text-center mt-3">Colores</h4>

    <h5 class="text-center mt-5">Background</h5>
    <koiote-color-picker-vue
      class="mt-1"
      :pcolor="selectedItem.customized.background_color"
      @event="change_background_color"
    ></koiote-color-picker-vue>

    <h5 class="text-center mt-5">Foreground</h5>
    <koiote-color-picker-vue
      class="mt-1"
      :pcolor="selectedItem.customized.foreground_color"
      @event="change_foreground_color"
    ></koiote-color-picker-vue>

    <h5 class="text-center mt-5">Borde</h5>
    <koiote-color-picker-vue
      class="mt-1"
      :pcolor="selectedItem.customized.border_color"
      @event="change_border_color"
    ></koiote-color-picker-vue>

    <h4 class="text-center mt-7">Propiedades</h4>
    <v-text-field
      prefix="Unidades:"
      class="ml-3 mr-3 mb-5"
      v-model="selectedItem.customized.units"
    >
    </v-text-field>

    <v-text-field
      prefix="Título:"
      class="ml-3 mr-3 mb-5"
      v-model="selectedItem.customized.label"

    >
    </v-text-field>

    <v-select
      v-model="selectedItem.customized.tipo_lectura"
      :items="options"
      label="Tipo de variable"
      item-value="value"
      item-text="text"
    ></v-select>
    <!-- Si es tipo PLC-->
    <div  v-if="selectedItem.customized.tipo_lectura==1">
      <v-text-field
        prefix="Dirección PLC:"
        class="ml-3 mr-3 mb-7"
        v-model="selectedItem.customized.address"
        single-line
        clearable
        :clear-icon-cb="selectedItem.customized.address == null ? updateEditing(true) : null"
      />
    </div>
    <!-- MQTT -->
    <div  v-if="selectedItem.customized.tipo_lectura==2">
      <v-text-field
        v-model="selectedItem.customized.topic_lectura"
        label="Topic de suscripción"
        hint="Introduce el topic para suscribirte"
        persistent-hint
      ></v-text-field>

      <v-select
        v-model="selectedItem.customized.textoValor"
        :items="options_texto_valor"
        label="Valor o texto"
        item-value="value"
        item-text="text"
      ></v-select>
     
      <div v-if="selectedItem.customized.textoValor==1">
        <v-text-field
          v-model="selectedItem.customized.memoria"
          label="Memoria"
          hint="Introduce el valor para comparar"
          persistent-hint
        />
      </div>
      <div v-if="selectedItem.customized.textoValor==2">
        <h5 class="text-center mt-5">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">Relación valor/texto</span>
            </template>
            <span>Cuando el valor que llega desde el topic de lectura elegido coincide con el valor, en su lugar se escribirá el texto asociado.</span>
          </v-tooltip>
        </h5>
        <v-list class="mt-4">
          <v-list-item-group v-if="selectedItem.customized.textRelation.length">
            <v-row 
              v-for="(item, index) in selectedItem.customized.textRelation" 
              :key="index" 
              class="align-center pa-0"
              style="margin: 4px 0;"
            >
              <!-- Campo Valor: más ancho -->
              <v-col cols="5" class="pa-0">
                <v-text-field
                  v-model="item.valor"
                  label="Valor"
                  outlined
                  dense
                  hide-details
                  class="py-1"
                  @input="updateTextRelation(index, item)"
                ></v-text-field>
              </v-col>
              
              <!-- Campo Texto: más ancho -->
              <v-col cols="5" class="pa-0">
                <v-text-field
                  v-model="item.texto"
                  label="Texto"
                  outlined
                  dense
                  hide-details
                  class="py-1"
                  @input="updateTextRelation(index, item)"
                ></v-text-field>
              </v-col>
              
              <!-- Botón de borrar: ocupa menos espacio y alineado con los campos -->
              <v-col cols="2" class="pa-0 d-flex align-center justify-center">
                <v-btn
                  icon
                  small
                  class="ma-0"
                  @click="deleteTextRelation(index)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-list-item-group>


          <!-- Botón para agregar nuevas filas -->
          <v-btn class="mt-3" small @click="addNewRow">Agregar nueva línea</v-btn>
        </v-list>


      </div>

    </div>
    

    <!-- <v-label class="ml-3"> Valor actual: {{ value }} </v-label> -->

  </v-container>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import KoioteColorPickerVue from "@/components/utils/KoioteColorPicker.vue";

export default {
  name: "KoioteValueLabelProperties",

  components: {
    KoioteColorPickerVue,
  },
  data() {
    return {
      selectedOption: 0,
      options: [
        { value: 0, text: '-' },
        { value: 1, text: 'Conexión PLC' },
        { value: 2, text: 'Broker MQTT' },
      ],
      selectedOptionTextoValor:0,
      options_texto_valor:[
        { value: 0, text: '-' },
        { value: 1, text: 'Valor' },
        { value: 2, text: 'Texto en función de valor' },
      ]
    }
  },
  computed: {
    ...mapState(["selectedItem","pages"]),
    ...mapGetters(["actualPage"]),


    value() {
      return (
        this.actualPage()
          .global_item_list.find((gi) => gi.settings.component_type.includes("connection"))
          .customized.vartable.find((v) => v.formatted_address == this.selectedItem.customized.address)?.value || 0
      );
    },
  },

  watch: {
    // Observa el cambio en topic_lectura
    'selectedItem.customized.topic_lectura'(newTopic, oldTopic) {
      // Si el topic ha cambiado y no es vacío
      if (oldTopic && oldTopic !== newTopic) {
        this.doUnsubscribe(oldTopic); // Desuscribirse del topic anterior
      }
      if (newTopic) {
        this.doSubscribe(newTopic);  // Suscribirse al nuevo topic
      }
    },
  },

  methods: {
    ...mapActions(["updateEditing"]),
    ...mapActions("nodered",["doUnsubscribe","doSubscribe"]),
    initializeTextRelation() {
      if (!this.selectedItem.customized.hasOwnProperty("textRelation")) {
        this.$set(this.selectedItem.customized, "textRelation", []);
      }
    },
    // Agregar nueva línea al array textRelation
    addNewRow() {
      this.selectedItem.customized.textRelation.push({
        valor: '',
        texto: '',
      });
    },
    deleteTextRelation(index) {
      this.selectedItem.customized.textRelation.splice(index, 1);
    },
    // Actualizar los valores en la posición correspondiente del array
    updateTextRelation(index, item) {
      this.$set(this.selectedItem.customized.textRelation, index, item);
    },
    getAllConections(){
      console.group("PAGINAS")
      this.pages.forEach((pagina) => {
        console.log(pagina)
        pagina.global_item_list.forEach((element) => {
          console.log(element)
        });
      });
      console.groupEnd();
    },

    change_background_color(nc) {
      this.selectedItem.customized.background_color = nc;
    },

    change_foreground_color(nc) {
      this.selectedItem.customized.foreground_color = nc;
    },

    change_border_color(nc) {
      this.selectedItem.customized.border_color = nc;
    },
  },

  mounted() {
    this.initializeTextRelation();
    this.getAllConections();
  },
};
</script>
